<template>
  <section id="contact-us">
    <div class="container">
      <div class="row">
        <div class="col-sm-12">
          <div class="title">
            <h3>
              <span style="color: #ff9955;">Secure </span
              ><span style="color: #49ad43;">File Upload</span>
            </h3>
          </div>
        </div>
      </div>
    </div>
    <div class="contact">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <secure-upload></secure-upload>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import SecureUpload from "./SecureUpload";
export default {
  components: {
    SecureUpload,
  },
};
</script>
